import laserImg from '../../assets/lasertreatment.avif'
import pigmentationImg from '../../assets/service43.webp'
import acneImg from '../../assets/Acne.jpg'
import peelsImg from '../../assets/Chemical-Peels.jpeg'
import hydrafacialImg from '../../assets/service21.webp'
import hairfallImg from '../../assets/service8.webp'
import scalpImg from '../../assets/hairtransplant.webp'
import scarsImg from '../../assets/microneedling.webp'
import rejuvenationImg from '../../assets/antiaging.jpeg'
import chooseImg from '../../assets/doctor.webp'

const blogData = [
  {
    slug: 'best-laser-hair-reduction-treatment',
    title: 'Best Laser Hair Reduction Treatment: What You Need to Know',
    metaDescription:
      'Everything you should know before getting laser hair reduction — how it works, number of sessions needed, aftercare, and who is the best candidate.',
    category: 'Laser Hair Reduction',
    image: laserImg,
    excerpt:
      "Thinking about permanent hair reduction? Here's how the treatment actually works, how many sessions you'll need, and what results to expect.",
    serviceLink: '/laser-hair-reduction',
    serviceLinkLabel: 'Laser Hair Reduction',
    sections: [
      {
        heading: 'How Laser Hair Reduction Works',
        paragraphs: [
          'Laser hair reduction uses focused light energy that is absorbed by the pigment (melanin) in each hair follicle. The heat generated damages the follicle enough to slow down and eventually stop future hair growth, without harming the surrounding skin.',
          'Because hair grows in cycles — active, resting, and shedding phases — a single session only targets the follicles that are in their active growth phase at that time. This is why the treatment is done in a series rather than as a one-time procedure.',
        ],
      },
      {
        heading: 'How Many Sessions Will You Need?',
        paragraphs: [
          'Most people need 6 to 8 sessions spaced around 4 to 6 weeks apart to see a significant, lasting reduction in hair growth. Areas like the upper lip and chin often respond faster, while the back, legs, and underarms may need a couple of extra sessions.',
          "Hair thickness, skin tone, hormonal factors, and the treatment area all affect how many sittings you'll personally need — which is why an in-person consultation matters more than a generic number.",
        ],
      },
      {
        heading: 'Aftercare Tips',
        paragraphs: [
          'Avoid direct sun exposure and always use sunscreen on the treated area for at least two weeks after each session. Skip hot showers, saunas, and harsh scrubs for 24-48 hours, and moisturise the area to soothe any mild redness.',
        ],
      },
    ],
    faqs: [
      {
        q: 'Is laser hair reduction painful?',
        a: "Most people describe it as a mild snapping sensation, similar to a rubber band flick. It's generally well tolerated, and numbing cream can be used for sensitive areas.",
      },
      {
        q: 'Is the result permanent?',
        a: "It's best described as long-term hair reduction rather than 100% permanent removal, since some fine, lighter hairs can regrow over the years due to hormonal changes.",
      },
      {
        q: 'Can all skin tones get laser hair reduction?',
        a: 'Yes, with the right laser technology and settings adjusted for your skin tone, the treatment can be done safely on most skin types.',
      },
    ],
  },
  {
    slug: 'pigmentation-treatment-causes-types-options',
    title: 'Pigmentation Treatment: Causes, Types & Treatment Options',
    metaDescription:
      'Understand what causes skin pigmentation, the different types like melasma and sunspots, and which treatments actually help even out your skin tone.',
    category: 'Pigmentation',
    image: pigmentationImg,
    excerpt: "Dark patches, sunspots, or melasma? Here's what's actually causing your pigmentation and which treatments can help fade it.",
    serviceLink: '/drSweta/pigmentation',
    serviceLinkLabel: 'Pigmentation Correction',
    sections: [
      {
        heading: 'What Causes Pigmentation?',
        paragraphs: [
          'Pigmentation occurs when your skin produces excess melanin in certain areas. Common triggers include prolonged sun exposure, hormonal changes (especially during pregnancy or with birth control), acne marks left behind after breakouts, and general skin ageing.',
        ],
      },
      {
        heading: 'Common Types of Pigmentation',
        paragraphs: [
          'Melasma usually appears as symmetrical brown patches on the cheeks, forehead, or upper lip, and is closely linked to hormones and sun exposure. Sunspots (or age spots) are small, flat, darker patches that develop from years of UV exposure. Post-inflammatory hyperpigmentation is the dark mark left behind after acne, cuts, or skin irritation heals.',
        ],
      },
      {
        heading: 'Treatment Options That Work',
        paragraphs: [
          'Chemical peels help exfoliate the top pigmented layer of skin and encourage fresh, even-toned skin to surface. Laser and light-based treatments target melanin directly and are effective for stubborn or deep-set pigmentation. Topical treatments and medical-grade skincare, combined with strict sun protection, are essential to prevent pigmentation from returning after any in-clinic procedure.',
        ],
      },
    ],
    faqs: [
      {
        q: 'Can pigmentation go away on its own?',
        a: 'Some post-acne marks fade gradually over months, but melasma and sunspots typically need active treatment and consistent sun protection to improve.',
      },
      {
        q: 'How long before I see results?',
        a: 'Most people notice visible improvement after 3-4 sessions, though full correction can take a few months depending on the depth and cause of the pigmentation.',
      },
      {
        q: 'Will pigmentation come back after treatment?',
        a: 'It can, especially without daily sunscreen use, since UV exposure is one of the biggest triggers for pigmentation recurrence.',
      },
    ],
  },
  {
    slug: 'acne-treatment-when-to-see-a-dermatologist',
    title: 'Acne Treatment: When Should You See a Dermatologist?',
    metaDescription:
      'Not sure if your acne needs a dermatologist? Learn the warning signs, at-home care that actually helps, and what professional treatments are available.',
    category: 'Acne',
    image: acneImg,
    excerpt: "Over-the-counter products not working? Here's how to know when it's time to see a dermatologist for your acne.",
    serviceLink: '/acne',
    serviceLinkLabel: 'Acne Treatment',
    sections: [
      {
        heading: "Signs You Shouldn't Wait Any Longer",
        paragraphs: [
          "If your acne is painful, cystic (large, deep bumps under the skin), leaving behind dark marks or scars, or simply not responding after 2-3 months of consistent at-home care, it's time to consult a dermatologist rather than keep experimenting on your own.",
          "Sudden, severe breakouts as an adult, or acne that's affecting your confidence and daily life, are also good reasons to get a professional opinion rather than wait it out.",
        ],
      },
      {
        heading: 'What a Dermatologist Can Offer',
        paragraphs: [
          'A dermatologist can correctly identify the type of acne you have — hormonal, cystic, fungal, or comedonal — and prescribe targeted treatment instead of generic products. This may include prescription topical treatments, oral medication when needed, and in-clinic procedures like chemical peels or laser therapy for stubborn cases.',
        ],
      },
      {
        heading: 'Preventing Acne Scars',
        paragraphs: [
          "Early treatment isn't just about clearing active acne — it also significantly reduces your risk of permanent scarring. Picking or popping acne at home is one of the biggest causes of long-term scars, so getting it under control early matters.",
        ],
      },
    ],
    faqs: [
      {
        q: 'Is diet really connected to acne?',
        a: 'For some people, high-sugar and high-dairy diets can worsen acne, but the impact varies from person to person, which is why a personalised assessment helps.',
      },
      {
        q: 'Do I need blood tests for acne?',
        a: 'Not always, but if hormonal acne is suspected — especially with irregular periods or excess facial hair — your dermatologist may recommend specific hormone tests.',
      },
      {
        q: 'Can adult acne be treated the same way as teenage acne?',
        a: 'Not exactly — adult acne is often hormonal and needs a different approach compared to typical teenage breakouts, so treatment is tailored accordingly.',
      },
    ],
  },
  {
    slug: 'chemical-peels-benefits-procedure-aftercare',
    title: 'Chemical Peels: Benefits, Procedure & Aftercare',
    metaDescription:
      'A complete guide to chemical peels — what they treat, what happens during the procedure, and how to take care of your skin afterward.',
    category: 'Chemical Peels',
    image: peelsImg,
    excerpt: "Curious about chemical peels? Here's what they actually treat, what to expect during the session, and how to care for your skin after.",
    serviceLink: '/drSweta/peels',
    serviceLinkLabel: 'Chemical Peels',
    sections: [
      {
        heading: 'What Chemical Peels Treat',
        paragraphs: [
          "Chemical peels use a controlled chemical solution to exfoliate the outer layers of skin, revealing smoother, more even-toned skin underneath. They're commonly used for acne and acne scars, pigmentation, dullness, fine lines, and uneven texture.",
        ],
      },
      {
        heading: 'What Happens During the Procedure',
        paragraphs: [
          "Your skin is first cleansed thoroughly, and the peel solution is applied evenly for a specific duration based on the peel strength and your skin's tolerance. You may feel a mild tingling or warm sensation, which typically subsides once the peel is neutralised or removed.",
        ],
      },
      {
        heading: 'Aftercare That Actually Matters',
        paragraphs: [
          "Expect some light flaking or peeling over the following days — this is completely normal and shouldn't be picked at. Strict sunscreen use is non-negotiable after a peel, since freshly exposed skin is far more sensitive to UV damage. Keep your skincare routine gentle for at least a week, avoiding active ingredients like retinol until your skin has fully recovered.",
        ],
      },
    ],
    faqs: [
      {
        q: 'Do chemical peels hurt?',
        a: 'Most peels cause only mild tingling or warmth. Deeper peels can feel more intense but are usually well managed with proper technique and aftercare.',
      },
      {
        q: 'How many peels will I need?',
        a: 'For general glow and mild concerns, a single session can help, but for pigmentation or acne scars, a series of 4-6 peels spaced a few weeks apart usually gives the best results.',
      },
      {
        q: 'Can I wear makeup after a peel?',
        a: "It's best to avoid makeup for at least 24 hours after your peel to let your skin breathe and recover properly.",
      },
    ],
  },
  {
    slug: 'hydrafacial-benefits-who-should-consider',
    title: 'HydraFacial: Benefits and Who Should Consider It?',
    metaDescription:
      "Is HydraFacial worth it? Learn how the treatment works, its key benefits, and whether it's the right fit for your skin concerns.",
    category: 'HydraFacial',
    image: hydrafacialImg,
    excerpt: "One of the most popular non-invasive facials out there — here's what HydraFacial actually does and who benefits from it most.",
    serviceLink: '/drSweta/hydrofacial',
    serviceLinkLabel: 'HydraFacial',
    sections: [
      {
        heading: 'How HydraFacial Works',
        paragraphs: [
          'HydraFacial is a multi-step treatment that cleanses, exfoliates, extracts impurities, and infuses the skin with hydrating serums — all using a single device, in one relaxing session with no downtime.',
        ],
      },
      {
        heading: 'Key Benefits',
        paragraphs: [
          'It instantly improves skin hydration, texture, and radiance, making it a popular choice before events or as a regular maintenance treatment. It also helps with mild congestion, clogged pores, and dullness, and is gentle enough to be customised for sensitive skin.',
        ],
      },
      {
        heading: 'Who Should Consider It',
        paragraphs: [
          "HydraFacial suits almost every skin type, including sensitive skin, since the intensity can be adjusted. It's a great option if you want visible glow with zero downtime, or as a complementary treatment alongside other skin concerns like pigmentation or fine lines.",
        ],
      },
    ],
    faqs: [
      {
        q: 'How often should I get a HydraFacial?',
        a: 'Most people benefit from a session every 4-6 weeks to maintain results, though this can vary based on your skin type and goals.',
      },
      {
        q: 'Is there any downtime?',
        a: 'None at all. You can resume your normal routine and even apply makeup immediately after the session.',
      },
      {
        q: 'Can HydraFacial help with acne-prone skin?',
        a: 'Yes, the extraction step can help clear clogged pores, though active or inflamed acne may need a more targeted treatment plan alongside it.',
      },
    ],
  },
  {
    slug: 'hair-fall-treatment-causes-and-solutions',
    title: 'Hair Fall Treatment: Common Causes and Available Solutions',
    metaDescription:
      'Struggling with hair fall? Understand the most common causes behind hair loss and the treatment options that can help restore healthier hair growth.',
    category: 'Hair Fall',
    image: hairfallImg,
    excerpt: "Excessive hair fall is more common than you think — here's what's usually behind it and how it can be treated effectively.",
    serviceLink: '/drSweta/regrowth',
    serviceLinkLabel: 'Hair Regrowth Treatment',
    sections: [
      {
        heading: 'Common Causes of Hair Fall',
        paragraphs: [
          'Hair fall can be triggered by several factors including nutritional deficiencies (like iron or vitamin D), hormonal imbalances, chronic stress, thyroid issues, post-pregnancy changes, and genetic pattern hair loss. Harsh styling habits and product overuse can also weaken hair over time.',
        ],
      },
      {
        heading: "How It's Diagnosed",
        paragraphs: [
          'A proper evaluation usually includes a scalp examination, a review of your medical and family history, and sometimes blood tests to rule out deficiencies or thyroid dysfunction. Identifying the actual cause is what makes treatment effective, rather than relying on generic hair products.',
        ],
      },
      {
        heading: 'Treatment Options',
        paragraphs: [
          'Depending on the cause, treatment may include topical growth solutions, mesotherapy, or oral medication for hormonal or nutritional causes. For advanced hair loss, hair transplant may be recommended as a long-term solution.',
        ],
      },
    ],
    faqs: [
      {
        q: 'Is some hair fall normal?',
        a: "Yes, losing around 50-100 strands a day is considered normal. It's excessive, sudden, or patchy hair fall that needs attention.",
      },
      {
        q: 'Can hair fall be reversed?',
        a: 'In many cases, especially when caused by deficiencies, stress, or hormonal factors, hair fall can be significantly improved with the right treatment.',
      },
      {
        q: 'How soon will I see results from treatment?',
        a: 'Hair growth is a slow process — most treatments need at least 3-4 months of consistency before visible improvement.',
      },
    ],
  },
  {
    slug: 'dandruff-vs-dry-scalp-difference',
    title: "Dandruff vs Dry Scalp: What's the Difference?",
    metaDescription:
      "Dandruff and dry scalp are often confused, but they need different treatment approaches. Here's how to tell them apart and treat each correctly.",
    category: 'Scalp Care',
    image: scalpImg,
    excerpt:
      "Flaky scalp? It could be dandruff or simply dryness — and treating the wrong one won't fix the problem. Here's how to tell the difference.",
    serviceLink: '/drSweta/regrowth',
    serviceLinkLabel: 'Hair & Scalp Treatment',
    sections: [
      {
        heading: 'What Causes Dandruff',
        paragraphs: [
          'Dandruff is usually caused by a yeast-like fungus called Malassezia that thrives on oily scalps, leading to irritation and larger, oily-looking flakes, often accompanied by itching or mild redness.',
        ],
      },
      {
        heading: 'What Causes Dry Scalp',
        paragraphs: [
          'Dry scalp, on the other hand, happens when the scalp lacks sufficient moisture — often due to harsh shampoos, cold weather, or overwashing. The flakes tend to be smaller, drier, and less oily than dandruff flakes.',
        ],
      },
      {
        heading: 'How to Treat Each Correctly',
        paragraphs: [
          'Dandruff typically responds well to anti-fungal or medicated shampoos containing ingredients like ketoconazole or zinc pyrithione. Dry scalp needs gentle, hydrating shampoos and scalp moisturising treatments instead — using an anti-dandruff shampoo on a simply dry scalp can actually make things worse.',
          "If flaking persists despite trying the right approach, a scalp consultation can help identify whether there's an underlying condition like seborrheic dermatitis or psoriasis that needs targeted treatment.",
        ],
      },
    ],
    faqs: [
      {
        q: 'Can dandruff cause hair fall?',
        a: 'Persistent, untreated dandruff can lead to scalp irritation and inflammation, which may contribute to increased hair shedding over time.',
      },
      {
        q: 'How often should I wash my hair if I have dandruff?',
        a: 'Generally 2-3 times a week with a medicated shampoo works well, though this can vary depending on your scalp type and the product used.',
      },
      {
        q: 'Is dandruff contagious?',
        a: "No, dandruff is not contagious — it's related to scalp oil production, fungus, and individual skin sensitivity, not something spread between people.",
      },
    ],
  },
  {
    slug: 'acne-scars-why-they-happen-and-treatment',
    title: 'Acne Scars: Why They Happen & How They Can Be Treated',
    metaDescription:
      'Learn why acne leaves scars behind, the different types of acne scars, and which treatments — from microneedling to lasers — actually help improve them.',
    category: 'Acne Scars',
    image: scarsImg,
    excerpt: "Acne scars can linger long after breakouts clear. Here's why they form and which treatments can genuinely help smooth them out.",
    serviceLink: '/drSweta/micro',
    serviceLinkLabel: 'Microneedling',
    sections: [
      {
        heading: 'Why Acne Leaves Scars',
        paragraphs: [
          "When acne inflammation damages the deeper layers of skin, the body's healing response can either produce too little or too much collagen — resulting in either indented (atrophic) scars or raised (hypertrophic/keloid) scars, depending on how the skin repairs itself.",
        ],
      },
      {
        heading: 'Common Types of Acne Scars',
        paragraphs: [
          'Ice pick scars are narrow and deep, boxcar scars are broader with defined edges, and rolling scars create a wave-like unevenness on the skin. Each type responds differently to treatment, which is why an accurate assessment matters before starting any procedure.',
        ],
      },
      {
        heading: 'Treatments That Help',
        paragraphs: [
          'Microneedling stimulates collagen production and works well for rolling and shallow scars. Chemical peels help improve overall texture and mild scarring. For deeper or more stubborn scars, combination approaches using lasers or fillers may be recommended for more noticeable improvement.',
        ],
      },
    ],
    faqs: [
      {
        q: 'Can acne scars be completely removed?',
        a: 'Most treatments significantly improve the appearance of scars rather than remove them 100%, but noticeable, lasting improvement is very achievable.',
      },
      {
        q: 'How many sessions are needed for microneedling?',
        a: 'Typically 4-6 sessions spaced 3-4 weeks apart are recommended for visible improvement in acne scarring.',
      },
      {
        q: 'Is it safe to treat scars while still getting occasional breakouts?',
        a: "It's best to get active acne under control first, since new breakouts can lead to new scars even as you're treating older ones.",
      },
    ],
  },
  {
    slug: 'skin-rejuvenation-treatment-options',
    title: 'Skin Rejuvenation Treatments: What Are Your Options?',
    metaDescription:
      'From laser therapy to microneedling — explore the range of skin rejuvenation treatments available to restore youthful, healthy-looking skin.',
    category: 'Skin Rejuvenation',
    image: rejuvenationImg,
    excerpt:
      'Sun damage, fine lines, uneven texture — skin rejuvenation covers a range of treatments designed to turn back the clock. Here are your options.',
    serviceLink: '/drSweta/rejuvention',
    serviceLinkLabel: 'Skin Rejuvenation',
    sections: [
      {
        heading: 'What Skin Rejuvenation Addresses',
        paragraphs: [
          'Over time, sun exposure, ageing, and lifestyle factors lead to fine lines, sunspots, uneven texture, and loss of skin firmness. Skin rejuvenation treatments are designed to target these concerns and restore a healthier, more youthful appearance.',
        ],
      },
      {
        heading: 'Popular Treatment Options',
        paragraphs: [
          "Laser therapy helps resurface the skin and stimulate collagen for firmer texture. Chemical peels exfoliate dull, damaged outer layers to reveal fresher skin underneath. Microneedling triggers your skin's natural repair process, improving both texture and tone with minimal downtime.",
        ],
      },
      {
        heading: 'Building a Rejuvenation Plan',
        paragraphs: [
          "Most people benefit from a combination approach rather than a single treatment, tailored to their specific skin concerns — whether that's pigmentation, sagging, or fine lines. A proper consultation helps map out the right sequence and timeline for visible, lasting results.",
        ],
      },
    ],
    faqs: [
      {
        q: 'At what age should I start skin rejuvenation treatments?',
        a: "There's no fixed age — it depends on your skin concerns. Some people start preventive treatments in their late 20s, while others begin once visible signs of ageing appear.",
      },
      {
        q: 'Are these treatments painful?',
        a: 'Most rejuvenation treatments cause only mild discomfort, and numbing options are available for more sensitive procedures.',
      },
      {
        q: 'How long do results last?',
        a: 'This varies by treatment type — some effects last several months, while consistent maintenance sessions help sustain results over the long term.',
      },
    ],
  },
  {
    slug: 'how-to-choose-right-dermatological-treatment',
    title: 'How to Choose the Right Dermatological Treatment for Your Skin',
    metaDescription:
      "Overwhelmed by treatment options? Here's a simple guide to help you choose the right dermatological treatment based on your actual skin concern.",
    category: 'Skin Care Guide',
    image: chooseImg,
    excerpt: "With so many treatments available, picking the right one can feel overwhelming. Here's how to make sense of your options.",
    serviceLink: '/appoint',
    serviceLinkLabel: 'Book a Consultation',
    sections: [
      {
        heading: 'Start With the Right Diagnosis',
        paragraphs: [
          "Before choosing any treatment, it's important to correctly identify what you're actually dealing with — is it pigmentation, active acne, ageing, or scarring? Many people jump straight to a popular treatment without understanding whether it even addresses their specific concern.",
        ],
      },
      {
        heading: 'Match the Treatment to the Concern',
        paragraphs: [
          'Active acne generally needs a different approach than acne scars. Pigmentation and ageing concerns often benefit from a combination of peels, lasers, or microneedling, rather than a single quick fix. Understanding this distinction avoids wasted time and money on ineffective treatments.',
        ],
      },
      {
        heading: 'Consider Downtime and Realistic Expectations',
        paragraphs: [
          "Some treatments require little to no downtime and can be done during a lunch break, while others need a few days of recovery. Being upfront with your dermatologist about your lifestyle and expectations helps them recommend a treatment plan that actually fits your routine — and delivers results you'll be happy with.",
        ],
      },
    ],
    faqs: [
      {
        q: 'Do I need a consultation before every treatment?',
        a: 'Yes, especially for your first visit — a proper skin assessment ensures the treatment plan is suited to your skin type and concern.',
      },
      {
        q: 'Can I combine multiple treatments in one plan?',
        a: 'Often, yes. Many effective treatment plans combine two or more approaches, spaced appropriately, for the best overall result.',
      },
      {
        q: 'How do I know if a treatment is working?',
        a: 'Most treatments show visible improvement within a few sessions. Your dermatologist should track your progress and adjust the plan if needed.',
      },
    ],
  },
]

export default blogData
